var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.hasAnyPerms([
    'admin.users.search' ]))?_c('CSidebarNavTitle',[_vm._v(_vm._s(_vm.$gettext('Customer Success')))]):_vm._e(),(_vm.hasAnyPerms(['admin.users.search']))?_c('CSidebarNavItem',{attrs:{"name":_vm.$gettext('Search User'),"to":{name: 'customer_success.search'},"icon":"cip-user"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }